import {
  Box,
  Container,
  Heading,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react"
import Thumb from "./Thumb"

export default function InputFile({ setFieldValue, name, label, value }) {

  const handleChange = (event) => {
    const file = event.currentTarget.files?.[0]
    setFieldValue(name, file)
  }

  return (
    <Container my="6">
      <Box
        borderColor="gray.300"
        borderWidth="2px"
        rounded="md"
        shadow="sm"
        role="group"
        transition="all 150ms ease-in-out"
        _hover={{ shadow: "md" }}
        cursor="pointer"
        position="relative"
        overflow="hidden"
      >
        <Stack padding={3}>
          <Heading fontSize="lg" color="gray.700" fontWeight="bold">
            {label}
          </Heading>
          <Text fontSize="sm" color="gray.500">
            Haz clic para seleccionar una imágen
          </Text>
        </Stack>

        <Input
          type="file"
          name={name}
          accept="image/*"
          onChange={handleChange}
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          opacity="0"
          cursor="pointer"
        />
      </Box>

      {value && (
        <Box
          mt={4}
          borderWidth="2px"
          rounded="md"
          shadow="sm"
          display="flex"
          justifyContent="center"
          p={3}
        >
          <Thumb file={value} />
        </Box>
      )}
    </Container>
  )
}
